import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Privacy <span className="text-yellow-500">Policy</span>
            </h1>
            <p className="text-gray-400">Effective Date: January 1, 2025</p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-300">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
              <p className="leading-relaxed">
                SpreadexAsia ("we," "our," "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website, platform, and services.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Information We Collect</h2>
              <p className="leading-relaxed mb-3">We may collect:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Account information (name, email, phone, identity documents)</li>
                <li>Transaction details (deposits, withdrawals, trading activity)</li>
                <li>Device and browser information</li>
                <li>Cookies and analytics data for improving our platform</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. How We Use Your Information</h2>
              <p className="leading-relaxed mb-3">We use your information to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide and improve trading services</li>
                <li>Process deposits, withdrawals, and transactions</li>
                <li>Communicate important updates, support messages, and notifications</li>
                <li>Ensure security and compliance with regulatory requirements</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Sharing of Information</h2>
              <p className="leading-relaxed mb-3">
                We do not sell your personal data. We may share data with:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Payment processors for transaction handling</li>
                <li>Service providers for hosting, analytics, or platform maintenance</li>
                <li>Legal authorities if required by law</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Security</h2>
              <p className="leading-relaxed">
                We implement technical and administrative measures to protect user data. While we take all reasonable steps, no system is completely immune to breaches.
              </p>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. User Rights</h2>
              <p className="leading-relaxed">
                You may request access, correction, or deletion of your personal data by contacting our support team at <a href="mailto:support@spreadex.asia" className="text-yellow-500 hover:text-yellow-400">support@spreadex.asia</a>.
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Cookies & Tracking</h2>
              <p className="leading-relaxed">
                We may use cookies and similar technologies to improve user experience and analyze usage patterns.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Minors</h2>
              <p className="leading-relaxed">
                Our services are only intended for individuals aged 18 and above.
              </p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Changes to This Policy</h2>
              <p className="leading-relaxed">
                We may update this Privacy Policy. Updates will be posted on the website with an updated "Effective Date."
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Contact Us</h2>
              <p className="leading-relaxed mb-3">For questions regarding privacy:</p>
              <ul className="space-y-2">
                <li>
                  <span className="font-semibold text-white">Email:</span>{' '}
                  <a href="mailto:support@spreadex.asia" className="text-yellow-500 hover:text-yellow-400">
                    support@spreadex.asia
                  </a>
                </li>
                <li>
                  <span className="font-semibold text-white">Phone:</span>{' '}
                  <span className="text-gray-400">+1 (800) 123-4567</span>
                </li>
              </ul>
            </section>
          </div>

          {/* CTA Section */}
          <div className="mt-16 bg-gradient-to-r from-yellow-900/30 to-gray-900 rounded-2xl p-8 text-center">
            <h3 className="text-2xl font-bold mb-4">Have Questions?</h3>
            <p className="text-gray-400 mb-6">
              Our support team is here to help you understand our privacy practices.
            </p>
            <a
              href="/contact"
              className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-8 py-3 rounded-xl transition-all duration-300"
            >
              Contact Support
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
